var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isHide),expression:"!isHide"}],class:[
        'floating-container',
        {
            isPC: !_vm.isH5
        }
    ],style:({
        zIndex: _vm.zIndex
    })},[_c('div',{ref:"moveContainerRef",class:['move-container', _vm.basePoint]},[_c('FreeContainer',{ref:"freeContainerRef",staticClass:"custom-free-container",attrs:{"children":_vm.tpl.children}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }